'use client';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, TextField } from '@mui/material';

import { useT } from '@/hooks';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  inputRef: React.RefObject<HTMLDivElement>;
  placeholder?: string;
  autoFocus?: boolean;
  borderless?: boolean;
  height?: number | string;
}

export const SearchInput = ({
  value,
  onChange,
  inputRef,
  placeholder,
  autoFocus = false,
  borderless = false,
  height = 'auto',
}: SearchInputProps) => {
  const { t } = useT();
  const defaultPlaceholder = t('common.searchPorvenix');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <TextField
      ref={inputRef}
      fullWidth
      placeholder={placeholder || defaultPlaceholder}
      value={value}
      onChange={handleChange}
      autoFocus={autoFocus}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear} sx={{ p: 0.5, color: 'text.secondary' }}>
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          bgcolor: borderless ? 'transparent' : 'background.default',
          borderRadius: 2,
          height: borderless ? 7 : height,
          '& fieldset': {
            borderColor: borderless ? 'transparent' : 'divider',
          },
          '&:hover fieldset': {
            borderColor: borderless ? 'transparent' : 'divider',
          },
          '&.Mui-focused fieldset': {
            borderColor: borderless ? 'transparent' : 'primary.main',
            borderWidth: borderless ? 0 : '1px',
          },
        },
      }}
    />
  );
};
